
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.894 6.333H6.106a.631.631 0 00-.631.632v6.944c0 .349.282.631.631.631h3.788a.631.631 0 00.631-.63V6.964a.631.631 0 00-.631-.632zM6.5 4.442c.423-.334 1.614-.8 3 0M5 2.935c.778-.706 3.067-1.693 6 0","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 9.5A.75.75 0 108 8a.75.75 0 000 1.5z","fill":"#4A4A4A"}})])
          )
        }
      }
    